import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "checked", "onChange", "size"],
  _excluded2 = ["fontSize", "marginBlockStart"];
import { createContext, useContext } from 'react';
import { RadioInput as RadioFoundations } from 'foundations-components/transitional/components/RadioInput';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { InputLabel } from '../Typography/InputLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const RadioContext = /*#__PURE__*/createContext({
  size: 'small'
});
export const Radio = _ref => {
  let {
      children,
      checked,
      onChange,
      size = 'small'
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleOnChange = event => {
    onChange === null || onChange === void 0 || onChange(event.target.checked);
  };
  return /*#__PURE__*/_jsx(RadioContext.Provider, {
    value: {
      size
    },
    children: /*#__PURE__*/_jsx(RadioFoundations, Object.assign({}, rest, spacingProps, {
      checked: checked,
      onChange: handleOnChange,
      size: size,
      children: children
    }))
  });
};
const RadioWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
RadioWrapper.displayName = 'InputWrapper';
Radio.Wrapper = RadioWrapper;
const sizeMap = {
  sm: 'base',
  small: 'base',
  default: 'lg'
};
const labelMarginMap = {
  sm: '-space-2xs',
  small: '-space-2xs',
  default: '-space-3xs'
};
const RadioLabel = _ref2 => {
  let {
      fontSize,
      marginBlockStart: providedMarginBlockStart
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    size = 'default'
  } = useContext(RadioContext);
  const sizeProp = fontSize || sizeMap[size];
  const marginBlockStart = providedMarginBlockStart !== null && providedMarginBlockStart !== void 0 ? providedMarginBlockStart : labelMarginMap[size];
  return /*#__PURE__*/_jsx(InputLabel, Object.assign({}, rest, {
    fontSize: sizeProp,
    marginBlockStart: marginBlockStart
  }));
};
Radio.Label = RadioLabel;